import SerializableObject from '@/utils/models/serializableobject.model';
import { ProductGroup } from '../menu/productgroup.model';

export default class ProductDivisionResponse extends SerializableObject {
  MenuProducts: ProductGroup[] = [];
}
